
import { Component, Vue } from 'vue-property-decorator';

import Form1ProcessHeader from "@/components/process/Form1/components/Form1ProcessHeader.vue";
import { form1StatusInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        Form1ProcessHeader
    }
})
export default class CancelSubmitForm1 extends Vue {

    stepsCompleted = {} as form1StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: true,
            fourth: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
